import { DotCMSLanguageItem } from 'dotcms/src/lib/models';

import { CustomerAttribute, CustomerSegment } from 'ish-core/models/customer/customer.model';

export class DotCmsConfigurationHelper {
  static getSelectedLanguageItem(selectedLocale: string, availableLanguages: DotCMSLanguageItem[]): DotCMSLanguageItem {
    const [languageCode] = selectedLocale.toLowerCase().split('_');
    return availableLanguages.find(language => language.languageCode.toLowerCase() === languageCode);
  }

  static getDotcmsSelectedLanguageItem(
    selectedLanguageId: number,
    availableLanguages: DotCMSLanguageItem[]
  ): DotCMSLanguageItem {
    return availableLanguages.find(language => +language.id === +selectedLanguageId);
  }

  static getCustomerSegmentPersonaId(customerSegments: CustomerSegment[]): string | undefined {
    const persona = customerSegments?.find(segment => segment.id.startsWith('CG_DOTCMS_'));
    if (persona?.id) {
      return persona.id.replace('CG_DOTCMS_', '');
    }
    return;
  }

  static getCustomerAttributePersonaId(attributes: CustomerAttribute[]): string | undefined {
    const persona = attributes?.find(attribute => attribute.name === 'Persona');
    if (persona?.value) {
      return persona.value;
    }
    return;
  }
}
